export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyCDtUaapraRa2tkNbUgzDrq5nVbja619Vs",
    authDomain: "pujasweb-app-303904.firebaseapp.com",
    projectId: "pujasweb-app-303904",
    storageBucket: "pujasweb-app-303904.appspot.com",
    messagingSenderId: "785305007470",
    appId: "1:785305007470:web:47606fbcad80cc9d937d7f",
    measurementId: "G-5HC6LJBJW7",
  },
  firebaseEmulator: {
    enabled: false,
    auth: {
      host: 'localhost',
      port: 5003,
    },
    firestore: {
      host: 'localhost',
      port: 5001,
    },
    storage: {
      host: 'localhost',
      port: 5002,
    },
    functions: {
      host: 'localhost',
      port: 5005,
    },
  },
  backend: {
    url: "https://meta-admin.pujasweb.co/api",
    widget: "https://meta.pujasweb.co/api",
  },
  openWeatherApiKey: '347cc121b608fa9f543bda56640226a0',
};
